module.exports = __webpack_public_path__ + "img/broadcast.9edfacb8.svg";